import { Fragment, useState, useMemo } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import Loading from "components/Loading";
import { getProductAnalysis } from "actions/spyAdvancedActions";
import useCallApi from "hook/useCallApi";
import SelectBox from "components/elements/selectBox";
import { formatNumberShort } from "components/Function";
import IlfChart from "./ilfchart";
import Groupedbarchart from "../../../shops/charts/Groupedbarchart";
import { MORE_FILTERS } from "../../../constant";
import Mixedchart from "../../../shops/charts/Mixedchart";

const DashboardOverview = ({ product, getProductAnalysis }) => {
    const { t } = useTranslation();
    const [type, setType] = useState("sales");
    const [filter, setFilter] = useState("30");

    const params = useMemo(() => {
        return {
            id: product.product_id,
            type: type === "sales" ? "total_sale_cnt" : "total_sale_gmv_amt",
            dateRange: filter,
        };
    }, [product.product_id, type, filter]);
    const paramsIfl = useMemo(() => {
        return {
            id: product.product_id,
            type: "total_ifl_cnt",
            dateRange: filter,
        };
    }, [product.product_id, filter]);
    const paramsVideo = useMemo(() => {
        return {
            id: product.product_id,
            tag: "basic.sales.insights",
            dateRange: filter,
        };
    }, [product.product_id, filter]);
    const paramOverview = useMemo(() => {
        return {
            id: product.product_id,
            tag: "basic.overview",
            dateRange: filter,
        };
    }, [product.product_id, filter]);

    const { data: dataMixed, loading } = useCallApi(getProductAnalysis, params);
    const { data: dataIfl } = useCallApi(getProductAnalysis, paramsIfl);
    const { data: dataVideo } = useCallApi(getProductAnalysis, paramsVideo);
    const { data: overview } = useCallApi(getProductAnalysis, paramOverview);

    return (
        <Fragment>
            <Loading isLoading={loading} />
            <div className="card mt-5 mb-5 mb-xl-10">
                <div className="card-header border-0 cursor-pointer align-items-center">
                    <div className="card-title m-0">
                        <h3 className="fw-bold m-0">{t("Overview")}</h3>
                    </div>
                    <SelectBox
                        options={MORE_FILTERS["dateRange"].map((item) => ({
                            value: item.id,
                            label: item.name,
                        }))}
                        style={{ height: "fit-content" }}
                        value={filter || "30"}
                        placeholder={t("Select Date Range")}
                        onChange={(data) => {
                            setFilter(data.value);
                        }}
                    />
                </div>
                <div>
                    <div className="d-flex justify-content-between align-items-center gap-8 m-4 px-20">
                        {overview?.data?.map((v, k) => (
                            <Fragment key={k}>
                                <div className="text-center">
                                    <div className="fw-bold fs-2">
                                        {v?.prefix} {formatNumberShort(v?.value)}
                                    </div>
                                    <div className="text-muted small">{v?.label}</div>
                                </div>
                                {overview?.data.length !== k + 1 && <div className="vr"></div>}
                            </Fragment>
                        ))}
                    </div>
                    <div className="col-12 d-flex justify-content-between mt-15 px-9">
                        <div>
                            <h3 className="fw-bold m-0">
                                {t("Sales Trend")} (
                                {filter === "1" ? "Yesterday" : (filter || "30") + " days"})
                            </h3>
                        </div>
                        <div className="btn-group">
                            <button
                                className={cx("btn", {
                                    "btn-primary": type === "sales",
                                    "btn-light": type !== "sales",
                                })}
                                onClick={() => setType("sales")}
                            >
                                {t("Sales")}
                            </button>
                            <button
                                className={cx("btn", { "btn-primary": type === "gmv", "btn-light": type !== "gmv" })}
                                onClick={() => setType("gmv")}
                            >
                                {t("GMV")}
                            </button>
                        </div>
                    </div>

                    <div className="d-flex">
                        <div className="d-flex col">
                            <Mixedchart
                                sales_trending_cnt={dataMixed?.data || []}
                                sales_trending_gmv_amt={dataMixed?.data || []}
                                type={type}
                            />
                        </div>
                    </div>
                    <div className="d-flex mt-10">
                        <div className="d-flex col">
                            <IlfChart influencer_trending={dataIfl?.data || []} />
                        </div>
                        <div className="d-flex col">
                            <Groupedbarchart video_trending={dataVideo?.data || []} filter={filter} />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default connect(null, { getProductAnalysis })(DashboardOverview);
